import moment from "moment";
import "moment/locale/es";
import { cuentaMask, dineroDisabledMask } from '../Components/Items'

moment.locale("es");

const reporteDeCuentasCliente = (values) => {
    const empresa = values.empresa
    const logoBiwo = values.logoBiwo;
    let filtrados = []
    if (values.clientes !== 0 && values.clientes && values.clientes.length > 0) {
        let textoFiltrado = ''
        values.clientes.map((valueCliente) => {
            textoFiltrado += `${(valueCliente.persona ? valueCliente.nombre : (valueCliente.nombre + ' ' + valueCliente.apellidoPaterno + ' ' + valueCliente.apellidoMaterno)) + valueCliente.razonSocial + " - " + valueCliente.rfc}\n`
            return null
        })
        filtrados.push([
            { text: 'Clientes:', style: 'subheader' },

            { text: textoFiltrado, style: 'textoChico' }
        ])
    }

    if (values.vendedores !== 0 && values.vendedores && values.vendedores.length > 0) {
        let textoFiltrado = ''
        values.vendedores.map((valueVendedores) => {
            textoFiltrado += `${valueVendedores.nombre +
                " " +
                valueVendedores.apellidoPaterno +
                " " +
                valueVendedores.apellidoMaterno}\n`
            return null
        })
        filtrados.push([
            { text: 'Vendedores:', style: 'subheader' },

            { text: textoFiltrado, style: 'textoChico' }
        ])
    }

    if (values.filtrarProyecto === 1) {
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            { text: 'Proyectos:', style: 'subheader' },

            { text: textoFiltrado, style: 'textoChico' }
        ])
    }

    if (values.filtrarProyecto === 2) {
        filtrados.push([
            { text: 'Unidad de Negocio:', style: 'subheader' },

            {
                text: `${cuentaMask(
                    values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 + values.unidadDeNegocio.nivel5
                ) +
                    " - " +
                    values.unidadDeNegocio.nombre}`, style: 'textoChico'
            }
        ])
    }

    let grupos = [];
    let grupoActual = [];


    for (const venta of values.ventas) {
        const esInsumo = venta.insumo === true;

        if (!esInsumo) {
            if (grupoActual.length > 0) {
                grupos.push(grupoActual);
            }
            grupoActual = [venta];
        } else {
            grupoActual.push(venta);
        }
    }
    if (grupoActual.length > 0) {
        grupos.push(grupoActual);
    }


    grupos.sort((a, b) => {
        const fechaA = moment(a[0].fechaFactura, "DD/MM/YYYY").toDate();
        const fechaB = moment(b[0].fechaFactura, "DD/MM/YYYY").toDate();
        return fechaA - fechaB;
    });


    //values.ventas = grupos.flat();

    //Dividir saldos de facturas 
    const saldosPorMoneda = {};
    const facturasPorMoneda = {};
    /*
    for (const valueVenta of values.ventas) {
        const monedaKey = valueVenta.moneda || 'Sin Moneda';

        if (valueVenta.saldoAFavor) {
            // Es saldo a favor
            if (!saldosPorMoneda[monedaKey]) saldosPorMoneda[monedaKey] = [];
            saldosPorMoneda[monedaKey].push(valueVenta);
        } else {
            // Es factura pendiente
            if (!facturasPorMoneda[monedaKey]) facturasPorMoneda[monedaKey] = [];
            facturasPorMoneda[monedaKey].push(valueVenta);
        }
    }*/

    grupos.forEach(grupo => {
        const cabeza = grupo[0]; 
        const monedaKey = cabeza.moneda || 'Sin Moneda';

        if (cabeza.saldoAFavor) {
            // Es grupo de Saldos a Favor
            if (!saldosPorMoneda[monedaKey]) saldosPorMoneda[monedaKey] = [];
            
            saldosPorMoneda[monedaKey].push(...grupo);
        } else {
            // Es grupo de Facturas Pendientes
            if (!facturasPorMoneda[monedaKey]) facturasPorMoneda[monedaKey] = [];
            facturasPorMoneda[monedaKey].push(...grupo);
        }
    });


    const tablasSaldos = [];
    if (Object.keys(saldosPorMoneda).length > 0) {
        tablasSaldos.push({ text: 'SALDOS A FAVOR', style: 'tableHeader', margin: [0, 10, 0, 5] });

        let granSaldosPagar = 0;
        let granSaldosPagado = 0;
        let granSaldosFinal = 0;

        Object.keys(saldosPorMoneda).forEach(moneda => {
            const items = saldosPorMoneda[moneda];

            let totalSaldosPagar = 0;
            let totalSaldosPagado = 0;
            let totalSaldosFinal = 0;

            const filasBody = items.map(valueVenta => {
                if (!valueVenta.insumo) {
                    totalSaldosPagar += valueVenta.totalPagar || 0;
                    totalSaldosPagado += valueVenta.totalPagado || 0; 
                    totalSaldosFinal += valueVenta.saldo || 0;
                }

                
                return [
                    { text: valueVenta.folio, style: 'textoTabla', alignment: 'left' },
                    { text: isNaN(valueVenta.fechaFactura) ? moment(valueVenta.fechaFactura, "DD/MM/YYYY").locale('es').format('L') : valueVenta.fechaFactura, style: 'textoTabla', alignment: 'center' },
                    { text: valueVenta.cliente, style: 'textoTabla', alignment: 'left' },
                    { text: dineroDisabledMask(valueVenta.total), style: 'textoTabla', alignment: 'right' },
                    { text: dineroDisabledMask(valueVenta.totalPagado), style: 'textoTabla', alignment: 'right' }, 
                    { text: dineroDisabledMask(valueVenta.saldo), style: 'textoTabla', alignment: 'right' },
                ];
            });

            granSaldosPagar += totalSaldosPagar;
            granSaldosPagado += totalSaldosPagado;
            granSaldosFinal += totalSaldosFinal;

            if (totalSaldosPagar > 0 || totalSaldosPagado > 0 || totalSaldosFinal > 0) {
                filasBody.push([
                    { text: 'Totales (' + moneda + '):', style: 'totalesTabla', alignment: 'left', colSpan: 3 },
                    {}, {},
                    { text: dineroDisabledMask(totalSaldosPagar), style: 'totalesTabla', alignment: 'right' },
                    { text: dineroDisabledMask(totalSaldosPagado), style: 'totalesTabla', alignment: 'right' },
                    { text: dineroDisabledMask(totalSaldosFinal), style: 'totalesTabla', alignment: 'right' },
                ]);
            }

            tablasSaldos.push(
                { text: `Moneda: ${moneda}`, style: 'subheader', margin: [0, 5, 0, 2] },
                {
                    style: 'tableExample',
                    table: {
                        widths: ['10%', '10%', '46%', '10%', '10%', '14%'],
                        headerRows: 1,
                        layout: { defaultBorder: true },
                        body: [
                            [
                                { text: 'Folio', style: 'tituloTabla' },
                                { text: 'Fecha', style: 'tituloTabla' },
                                { text: 'Cliente', style: 'tituloTabla' },
                                { text: 'Total', style: 'tituloTabla' },
                                { text: 'Abonos', style: 'tituloTabla' },
                                { text: 'Saldo', style: 'tituloTabla' },
                            ],
                            ...filasBody
                        ]
                    },
                    layout: {
                        fillColor: (r) => r % 2 === 0 ? "#e8e8e8" : "#ffffff",
                        hLineWidth: (i, node) => (i === 0 || i === node.table.body.length) ? 1 : 1,
                        vLineWidth: (i, node) => (i === 0 || i === node.table.widths.length) ? 1 : 1,
                        hLineColor: () => '#adaaaa',
                        vLineColor: () => '#adaaaa',
                        hLineStyle: (i, node) => (i === 0 || i === node.table.body.length) ? null : { dash: { length: 2, space: 1 } },
                        vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length) ? null : { dash: { length: 2 } }
                    }
                }
            );
        });

        if (granSaldosPagar > 0 || granSaldosPagado > 0 || granSaldosFinal > 0) {
            tablasSaldos.push({
                style: 'tableExample',
                table: {
                    widths: ['10%', '10%', '46%', '10%', '10%', '14%'],
                    body: [[
                        { text: 'GRAN TOTAL:', style: 'totalesTabla', alignment: 'left', colSpan: 3, fillColor: '#aaaaaa' },
                        {}, {},
                        { text: dineroDisabledMask(granSaldosPagar), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                        { text: dineroDisabledMask(granSaldosPagado), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                        { text: dineroDisabledMask(granSaldosFinal), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                    ]]
                },
                layout: { hLineWidth: () => 1, vLineWidth: () => 1, hLineColor: () => '#aaaaaa', vLineColor: () => '#aaaaaa' }
            });
        }
    }

    const tablasFacturas = [];
    if (Object.keys(facturasPorMoneda).length > 0) {
        tablasFacturas.push({ text: 'FACTURAS PENDIENTES', style: 'tableHeader', margin: [0, 10, 0, 5] });

        let granFacturasTotales = 0;
        let granFacturasAbonos = 0;
        let granFacturasSaldo = 0;

        Object.keys(facturasPorMoneda).forEach(moneda => {
            const items = facturasPorMoneda[moneda];

            let totalTotales = 0;
            let totalAbonos = 0;
            let totalSaldo = 0;
            let totalVencido = 0;
            let totalNoVencido = 0;

            const filasBody = items.map(valueVenta => {
                const properties = valueVenta.colorStyle ? { background: valueVenta.colorStyle } : {}
                
                if (!valueVenta.insumo) {
                    totalTotales += valueVenta.total || 0;
                    totalAbonos += valueVenta.totalPagado || 0;
                    totalSaldo += valueVenta.saldo || 0;

                    if (typeof valueVenta.fechaVencimiento === 'string' && moment(valueVenta.fechaVencimiento, "DD/MM/YYYY", true).isValid()) {
                        if (moment(valueVenta.fechaVencimiento, "DD/MM/YYYY").isBefore(moment())) {
                            totalVencido += valueVenta.saldo || 0;
                        } else {
                            totalNoVencido += valueVenta.saldo || 0;
                        }
                    }

                    return [
                        { text: valueVenta.folio, style: 'textoTabla', alignment: 'left' },
                        { text: isNaN(valueVenta.fechaFactura) ? moment(valueVenta.fechaFactura, "DD/MM/YYYY").locale('es').format('L') : valueVenta.fechaFactura, style: 'textoTabla', alignment: 'center' },
                        { text: valueVenta.cliente + (valueVenta.ordenDeCompra ? ("\nOC: " + valueVenta.ordenDeCompra) : ""), style: 'textoTabla', alignment: 'left' },
                        {
                            text: typeof valueVenta.fechaVencimiento === 'string' && moment(valueVenta.fechaVencimiento, "DD/MM/YYYY", true).isValid()
                                ? moment(valueVenta.fechaVencimiento, "DD/MM/YYYY").locale('es').format('L')
                                : '-',
                            style: 'textoTabla',
                            alignment: 'center'
                        },
                        { text: valueVenta.estado, ...properties, style: 'textoTabla', alignment: 'left' },
                        { text: dineroDisabledMask(valueVenta.totalPagar), style: 'textoTabla', alignment: 'right' },
                        { text: dineroDisabledMask(valueVenta.totalPagado), style: 'textoTabla', alignment: 'right' },
                        { text: dineroDisabledMask(valueVenta.saldo), style: 'textoTabla', alignment: 'right' },
                    ];
                } 
                else {
                    return [
                        { text: '', style: 'textoTabla' }, 
                        { text: valueVenta.fechaFactura, style: 'textoTabla', alignment: 'center' }, // Cantidad
                        { text: valueVenta.cliente, style: 'textoTabla', alignment: 'left', colSpan: 2 }, // Descripción
                        {}, 
                        { text: dineroDisabledMask(valueVenta.estado), style: 'textoTabla', alignment: 'right' }, // Total Línea 
                        { text: dineroDisabledMask(valueVenta.total), style: 'textoTabla', alignment: 'right' }, // Precio Unitario
                        { text: dineroDisabledMask(valueVenta.totalPagado), style: 'textoTabla', alignment: 'right' },
                        { text: dineroDisabledMask(valueVenta.saldo), style: 'textoTabla', alignment: 'right' },
                    ];
                }
            });

            granFacturasTotales += totalTotales;
            granFacturasAbonos += totalAbonos;
            granFacturasSaldo += totalSaldo;

            // Totales por Moneda
            if (totalTotales > 0 || totalAbonos > 0 || totalSaldo > 0) {
                filasBody.push([
                    { text: 'Totales (' + moneda + '):', style: 'totalesTabla', alignment: 'left', colSpan: 5 },
                    {}, {}, {}, {},
                    { text: dineroDisabledMask(totalTotales), style: 'totalesTabla', alignment: 'right' },
                    { text: dineroDisabledMask(totalAbonos), style: 'totalesTabla', alignment: 'right' },
                    { text: dineroDisabledMask(totalSaldo), style: 'totalesTabla', alignment: 'right' },
                ], [
                    { text: 'Total Vencido (' + moneda + '):', style: 'totalesTabla', alignment: 'left', colSpan: 5 },
                    {}, {}, {}, {},
                    { text: dineroDisabledMask(totalVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3 },
                    {}, {}
                ], [
                    { text: 'Total No Vencido (' + moneda + '):', style: 'totalesTabla', alignment: 'left', colSpan: 5 },
                    {}, {}, {}, {},
                    { text: dineroDisabledMask(totalNoVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3 },
                    {}, {}
                ]);
            }

            tablasFacturas.push(
                { text: `Moneda: ${moneda}`, style: 'subheader', margin: [0, 5, 0, 2] },
                {
                    style: 'tableExample',
                    table: {
                        widths: ['8%', '10%', '28%', '10%', '10%', '10%', '10%', '14%'],
                        headerRows: 1,
                        layout: { defaultBorder: true },
                        body: [
                            [
                                { text: 'Folio', style: 'tituloTabla' },
                                { text: 'Fecha', style: 'tituloTabla' },
                                { text: 'Cliente', style: 'tituloTabla' },
                                { text: 'Vencimiento', style: 'tituloTabla' },
                                { text: 'Estado', style: 'tituloTabla' },
                                { text: 'Total', style: 'tituloTabla' },
                                { text: 'Abonos', style: 'tituloTabla' },
                                { text: 'Saldo', style: 'tituloTabla' },
                            ],
                            ...filasBody
                        ]
                    },
                    layout: {
                        fillColor: (r) => r % 2 === 0 ? "#e8e8e8" : "#ffffff",
                        hLineWidth: (i, node) => (i === 0 || i === node.table.body.length) ? 1 : 1,
                        vLineWidth: (i, node) => (i === 0 || i === node.table.widths.length) ? 1 : 1,
                        hLineColor: () => '#adaaaa',
                        vLineColor: () => '#adaaaa',
                        hLineStyle: (i, node) => (i === 0 || i === node.table.body.length) ? null : { dash: { length: 2, space: 1 } },
                        vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length) ? null : { dash: { length: 2 } }
                    }
                }
            );
        });

        if (granFacturasTotales > 0 || granFacturasAbonos > 0 || granFacturasSaldo > 0) {
            tablasFacturas.push({
                style: 'tableExample',
                table: {
                    widths: ['8%', '10%', '28%', '10%', '10%', '10%', '10%', '14%'],
                    body: [[
                        { text: 'GRAN TOTAL:', style: 'totalesTabla', alignment: 'left', colSpan: 5, fillColor: '#aaaaaa' },
                        {}, {}, {}, {},
                        { text: dineroDisabledMask(granFacturasTotales), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                        { text: dineroDisabledMask(granFacturasAbonos), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                        { text: dineroDisabledMask(granFacturasSaldo), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                    ]]
                },
                layout: { hLineWidth: () => 1, vLineWidth: () => 1, hLineColor: () => '#aaaaaa', vLineColor: () => '#aaaaaa' }
            });
        }
    }

    if (filtrados.length === 0) {
        filtrados.push([
            { text: 'No tiene filtrados adicionales', style: 'subheader' },

            { text: '', style: 'textoChico' }
        ])
    }

    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: ['18%', '52%', '30%'],
                    layout: {
                        defaultBorder: false,
                    },
                    body: [
                        [
                            {
                                //							rowSpan: 3,
                                border: [false, false, false, false],
                                image: 'logo',
                                fit: [80, 80]
                                //text: 'rowSpan: 3\n\nborder:\n[true, true, true, true]'
                            },
                            {
                                //	rowSpan: 2,
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],

                                    body: [
                                        [
                                            {
                                                text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre+' '+empresa.apellidoPaterno+' '+empresa.apellidoMaterno),
                                                style: "tableHeader"
                                            }
                                        ],
                                        [
                                            {
                                                text: "R.F.C: " + empresa.rfc,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.calle + ' ' +
                                                    empresa.numeroCalle + ' ' +
                                                    (empresa.numeroInterior ? empresa.numeroInterior : '')
                                                ,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.colonia.tipoAsentamiento + ' ' +
                                                    empresa.colonia.nombre + ' C.P. ' +
                                                    empresa.colonia.cp + ' ' +
                                                    empresa.municipio.nombre + ' ' +
                                                    empresa.estado.abreviatura + ' ' +
                                                    empresa.pais.abreviatura + ' '
                                                ,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [{ text: 'ESTADO DE CUENTA CLIENTE', style: 'tableHeader' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],

                                    body: [
                                        [{ text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center' }],
                                        [{ text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                        [{ text: 'Desglose:', style: 'subheader', alignment: 'center' }],
                                        [{ text: values.detalle ? 'Si' : 'No', style: 'textoChico', alignment: 'center' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                        ]

                    ]
                },
            },
            { text: 'Datos de filtrado:' },
            {
                style: 'tableExample',
                table: {
                    widths: ['20%', '80%'],
                    layout: {
                        defaultBorder: false,
                    },

                    body: filtrados,
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return { dash: { length: 2, space: 1 } };
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return { dash: { length: 2 } };
                    },
                    // paddingLeft: function(i, node) { return 4; },
                    // paddingRight: function(i, node) { return 4; },
                    // paddingTop: function(i, node) { return 2; },
                    // paddingBottom: function(i, node) { return 2; },
                    // fillColor: function (i, node) { return null; }
                }

            },
            /*
            [{ text: 'SALDOS A FAVOR', style: 'tableHeader' }],
            {
                style: 'tableExample',
                table: {
                    widths: ['10%', '10%', '46%', '10%', '10%', '14%'],
                    layout: {
                        defaultBorder: true,
                    },
                    body: [
                        [
                            { text: 'Folio', style: 'tituloTabla' },
                            { text: 'Fecha', style: 'tituloTabla' },
                            { text: 'Cliente', style: 'tituloTabla' },
                            // { text: 'Vencimiento', style: 'tituloTabla' },
                            // { text: 'Estado', style: 'tituloTabla' },
                            // { text: 'Vendedor', style: 'tituloTabla' },
                            { text: 'Total', style: 'tituloTabla' },
                            { text: 'Abonos', style: 'tituloTabla' },
                            { text: 'Saldo', style: 'tituloTabla' },
                        ],
                        //Falta esto en el backend y ya
                        ...saldosAFavor,
                    ]
                },
                layout: {
                    fillColor: (rowIndex, node, columnIndex) => {
                        return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                    },
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return { dash: { length: 2, space: 1 } };
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return { dash: { length: 2 } };
                    },
                    // paddingLeft: function(i, node) { return 4; },
                    // paddingRight: function(i, node) { return 4; },
                    // paddingTop: function(i, node) { return 2; },
                    // paddingBottom: function(i, node) { return 2; },
                    // fillColor: function (i, node) { return null; }
                }
            },

            [{ text: 'FACTURAS PENDIENTES', style: 'tableHeader' }],
            {
                style: 'tableExample',
                table: {
                    widths: ['8%', '10%', '28%', '10%', '10%', '10%', '10%', '14%'],
                    layout: {
                        defaultBorder: true,
                    },
                    body: [
                        [
                            { text: 'Folio', style: 'tituloTabla' },
                            { text: 'Fecha', style: 'tituloTabla' },
                            { text: 'Cliente', style: 'tituloTabla' },
                            { text: 'Vencimiento', style: 'tituloTabla' },
                            { text: 'Estado', style: 'tituloTabla' },
                            // { text: 'Vendedor', style: 'tituloTabla' },
                            { text: 'Total', style: 'tituloTabla' },
                            { text: 'Abonos', style: 'tituloTabla' },
                            { text: 'Saldo', style: 'tituloTabla' },
                        ],
                        //Falta esto en el backend y ya
                        ...ventas,
                    ]
                },
                layout: {
                    fillColor: (rowIndex, node, columnIndex) => {
                        return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                    },
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return { dash: { length: 2, space: 1 } };
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return { dash: { length: 2 } };
                    },
                    // paddingLeft: function(i, node) { return 4; },
                    // paddingRight: function(i, node) { return 4; },
                    // paddingTop: function(i, node) { return 2; },
                    // paddingBottom: function(i, node) { return 2; },
                    // fillColor: function (i, node) { return null; }
                }
            },
            */
            ...tablasSaldos,
            ...tablasFacturas,
        ],
        images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
        },
        styles: {
            header: {
                fontSize: 9,
                bold: true,
            },
            subheader: {
                fontSize: 8,
                bold: true,
            },
            tableExample: {
                margin: [0, 5, 0, 5]
            },
            tablaSinMargen: {
                margin: [0, 0, 0, 0]
            },
            tableHeader: {
                bold: true,
                fontSize: 12,
                color: 'black',
                alignment: 'center'
            },
            textoChico: {
                fontSize: 8
            },
            tituloTabla: {
                fontSize: 8,
                bold: true,
                fillColor: '#cccccc',
                style: 'subheader',
                alignment: 'center',
                border: true
            },
            textoTabla: {
                fontSize: 8,
                italics: false
            },
            totalesTabla: {
                fontSize: 8,
                bold: true,
                italics: false,
                fillColor: '#cccccc',
            }
        },
        pageSize: 'LETTER',
        pageMargins: [20, 20, 20, 60],
    }
    return dd;
};


export default reporteDeCuentasCliente;
